import { render, staticRenderFns } from "./access_denied_empty_state.vue?vue&type=template&id=a87b264a"
import script from "./access_denied_empty_state.vue?vue&type=script&lang=js"
export * from "./access_denied_empty_state.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports